import { defineNuxtPlugin } from '#app'
import hljs from 'highlight.js/lib/core'
import python from 'highlight.js/lib/languages/python'
import javascript from 'highlight.js/lib/languages/javascript'
import typescript from 'highlight.js/lib/languages/typescript'
import java from 'highlight.js/lib/languages/java'
import c from 'highlight.js/lib/languages/c'
import cpp from 'highlight.js/lib/languages/cpp'
import cshap from 'highlight.js/lib/languages/csharp'
import sql from 'highlight.js/lib/languages/sql'
import xml from 'highlight.js/lib/languages/xml'
import php from 'highlight.js/lib/languages/php'
import swift from 'highlight.js/lib/languages/swift'
import r from 'highlight.js/lib/languages/r'
import go from 'highlight.js/lib/languages/go'
import bash from 'highlight.js/lib/languages/bash'
import markdown from 'highlight.js/lib/languages/markdown'
import kotlin from 'highlight.js/lib/languages/kotlin'
import rust from 'highlight.js/lib/languages/rust'

export default defineNuxtPlugin(() => {
  hljs.registerLanguage('markdown', markdown)
  hljs.registerLanguage('javascript', javascript)
  hljs.registerLanguage('java', java)
  hljs.registerLanguage('python', python)
  hljs.registerLanguage('csharp', cshap)
  hljs.registerLanguage('php', php)
  hljs.registerLanguage('swift', swift)
  hljs.registerLanguage('typescript', typescript)
  hljs.registerLanguage('go', go)
  hljs.registerLanguage('kotlin', kotlin)
  hljs.registerLanguage('bash', bash)
  hljs.registerLanguage('html', xml)
  hljs.registerLanguage('c', c)
  hljs.registerLanguage('cpp', cpp)
  hljs.registerLanguage('sql', sql)
  hljs.registerLanguage('r', r)
  hljs.registerLanguage('rust', rust)
  hljs.registerLanguage('xml', xml)
  hljs.configure({
    ignoreUnescapedHTML: true
  })
})
